/* GYMMONKY: launch discount one-click cart application.
 * Ajax cart/update.js is supported by Shopify for discount codes (since May 2025).
 * This delegates from dynamically updated cart and drawer content.
 */
(function () {
  'use strict';
  if (window.gmCartPromoListenerInstalled) return;
  window.gmCartPromoListenerInstalled = true;

  document.addEventListener('click', async function (event) {
    var element = event.target;
    if (!(element instanceof Element)) return;
    var link = element.closest('a[data-gm-promo-apply]');
    if (!link) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;

    var scope = link.closest('cart-drawer, main-cart');
    var sectionId = scope && scope.getAttribute('data-section-id');
    var code = (link.getAttribute('data-gm-promo-apply') || '').trim();
    if (!sectionId || !code || !window.fetch) {
      window.location.assign(link.href);
      return;
    }

    var panel = link.closest('.gm-promo--cart');
    var error = panel && panel.querySelector('[data-gm-promo-error]');
    var success = panel && panel.querySelector('[data-gm-promo-success]');
    if (error) { error.hidden = true; error.textContent = ''; }
    if (success) success.hidden = true;
    link.setAttribute('aria-busy', 'true');
    link.style.opacity = '0.65';
    link.style.pointerEvents = 'none';

    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (!root.endsWith('/')) root += '/';
      var cartGet = await fetch(root + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!cartGet.ok) throw new Error('Cart retrieval failed');
      var before = await cartGet.json();

      var codes = (before.discount_codes || [])
        .filter(function (discount) { return discount && discount.code && discount.applicable !== false; })
        .map(function (discount) { return discount.code; });
      var alreadyIncluded = codes.some(function (existing) {
        return existing.toLowerCase() === code.toLowerCase();
      });
      if (!alreadyIncluded) codes.push(code);

      var sections = [sectionId];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
        bubbles: true,
        detail: { sections: sections }
      }));
      sections = Array.from(new Set(sections.filter(Boolean)));

      var theme = window.theme;
      var updateUrl = (theme && theme.routes && theme.routes.cart_update_url) || root + 'cart/update.js';
      var response = await fetch(updateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(','), sections: sections })
      });
      if (!response.ok) throw new Error('Cart update failed');
      var updated = await response.json();
      var applied = (updated.discount_codes || []).some(function (discount) {
        return discount && discount.code && discount.code.toLowerCase() === code.toLowerCase() && discount.applicable === true;
      });

      if (!applied) throw new Error('Discount is not applicable');

      link.hidden = true;
      if (success) success.hidden = false;

      if (updated.sections && theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS && theme.pubsub.publish) {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: 'gm-cart-promo',
          cart: updated
        });
      } else {
        window.location.reload();
      }
    } catch (err) {
      if (error) {
        error.textContent = link.getAttribute('data-gm-promo-error-text') || 'Discount could not be applied.';
        error.hidden = false;
      }
      console.warn('GYMMONKY promotion could not be applied:', err);
    } finally {
      link.removeAttribute('aria-busy');
      link.style.opacity = '';
      link.style.pointerEvents = '';
    }
  });
})();
